import { h } from 'preact';
import * as BaseComp from 'components/bolt/hub/components/buttons/buttons.js';
import Store from 'store/store';
import { navigateInternally } from 'utils/bolt/index';
import { smoothScrollTo } from 'utils/smoothScroll';
import { fade } from 'utils/bolt/transitions';

// import s from 'components/bolt/hub/components/buttons/buttons.sss';

export default class Buttons extends BaseComp.default {

	async triggerAction(path, label, sameWindow, videoOverlay) {
		const { carouselTitle, filmTitle } = this.props;

		const { activePage } = Store.get();
		const isSearchPage = activePage === 'search';

		Store.emit('CUSTOM_EVENT', {
			category: activePage.replace('Scroll', ''),
			action: (isSearchPage ? 'search' : carouselTitle) + '_tile-click_' + filmTitle,
			label: label
		});

		if (videoOverlay) {
			return Store.emit('ENABLE_TRAILER_OVERLAY', videoOverlay);
		}
		if (path === 'scrollTop') {
			return smoothScrollTo(document.getElementById('mainScroll'), 0, 300);
		}

		// const mainScroll = document.getElementById('mainScroll');
		// const logo = label.toLowerCase() === 'logo';
		// const isRootPath = activePage?.path === '/';
		// if (isRootPath && logo) {
		// 	return smoothScrollTo(mainScroll, 0, 300);
		// }

		await fade(document.getElementById('mainScroll'), 'out', 500);

		navigateInternally(path);
		fade(document.getElementById('mainScroll'), 'in', 700);
	}

}
